import { Immutable } from "immer";
import React from "react";
import { OfferModal } from "tsi-common-react/src/components/OfferModal/index";

import type { EverydayOfferGridBlock as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";

type Props = Immutable<{
    value: Value;
}>;

/**
 * Faithful port of the legacy server-rendered `everyday-offer-grid-block.html`.
 * The outer `everybody-offer-grid-block` class is a real typo in the original
 * markup and is reproduced verbatim. Each tile rendered a `width-50` Wagtail
 * image, an OfferModal trigger (previously a nested `include_react` of
 * `OfferModalTemplate`, now the component directly as a child), a divider bar,
 * and a rich-text description.
 */
export const EverydayOfferGridBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    return (
        <section className="everybody-offer-grid-block">
            <div className="l-capped-width">
                {(v.tiles ?? []).map((tile, i) => (
                    // Index key: ListBlock tiles don't surface a stable id, so a
                    // CMS reorder reuses positional DOM — matches the legacy
                    // `forloop`-positional render.
                    <div className="everyday-offer-tile-block" key={i}>
                        {tile.image ? (
                            <img
                                alt={tile.image.default_alt_text}
                                src={tile.image.renditions["width-50"].url}
                                loading="lazy"
                                decoding="async"
                            />
                        ) : null}
                        {/* Legacy passed the already-rendered rich-text HTML
                            (header_text|richtext) as cta_text; OfferModal
                            dangerouslySetInnerHTMLs it, so pass it raw. */}
                        <OfferModal
                            offerDetailURL={tile.page?.url ?? ""}
                            ctaText={tile.header_text ?? undefined}
                            ctaArrow={false}
                            isButton={false}
                        />
                        <div className="everyday-offer-tile-block__bar"></div>
                        <div className="everyday-offer-tile-block__description">
                            <RichTextBlock value={tile.description ?? ""} />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};
